/// <amd-module name="Tfs/Header/Components/Components/HeaderBreadcrumb/HeaderBreadcrumb" />
import * as React from "react";

import { IReadonlyObservableArray } from "VSS/Core/Observable";
import { ScreenSize } from "VSS/Core/Util/Screen";
import { getBreadcrumbItems } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IVssComponentContext, IVssComponentDetail, IVssLayoutManager, RegionComponent, VssComponent } from "VSS/Platform/Layout";
import { IVssPerformanceService } from "VSS/Platform/Performance";
import { Breadcrumb, IBreadcrumbItem } from "VSSUI/Breadcrumb";
import { Observer } from "VSSUI/Observer";
import { ScreenSizeConditional } from "VSSUI/Utilities/ScreenSize";

interface IHeaderBreadcrumbState {
    isVisible: boolean;
    breadcrumbItems: IReadonlyObservableArray<IBreadcrumbItem>;
    extraContentSelected: boolean;
}

class HeaderBreadcrumb extends VssComponent<{}, IHeaderBreadcrumbState> {
    public static componentType = "headerBreadcrumb";

    private _breadcrumbItemProvider: IReadonlyObservableArray<IBreadcrumbItem>;
    private _headerComponents: IReadonlyObservableArray<IVssComponentDetail>;
    private _layoutManager: IVssLayoutManager;

    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        this._layoutManager = context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        this._headerComponents = this._layoutManager.getComponentsForRegion("headerBreadcrumb");
        this._breadcrumbItemProvider = getBreadcrumbItems(this.context.pageContext, "ms.vss-tfs-web.vertical-header-breadcrumb");
        this.state = { isVisible: true, breadcrumbItems: this._breadcrumbItemProvider, extraContentSelected: false };
    }

    public componentDidMount() {
        super.componentDidMount();

        const performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        performanceService.endScenario("tfs", "WebPlatform.Frame", false);

        this.addEventListener(window, "searchExpanded", this.onSearchExpanded);
        this.addEventListener(window, "searchCollapsed", this.onSearchCollapsed);
    }

    public render() {
        let extraBreadcrumbContent: JSX.Element | undefined;

        if (!this.state.isVisible) {
            return <div className="flex-grow" />;
        }

        return (
            <Observer items={this.state.breadcrumbItems} headerComponents={this._headerComponents}>
                {(props: { items: IBreadcrumbItem[]; headerComponents: IVssComponentDetail[] }) => {
                    if (props.headerComponents.length) {
                        extraBreadcrumbContent = (
                            <RegionComponent
                                className="flex-row"
                                componentRegion="headerBreadcrumb"
                                childComponentProperties={{ selected: this.state.extraContentSelected }}
                            />
                        );
                    }
                    return (
                        <ScreenSizeConditional condition={screenSize => screenSize > ScreenSize.xsmall}>
                            <Breadcrumb
                                excludeTabStop={true}
                                className="header-breadcrumb flex-grow"
                                extraContent={extraBreadcrumbContent}
                                items={props.items}
                                extraContentClassName="extra-content"
                            />
                        </ScreenSizeConditional>
                    );
                }}
            </Observer>
        );
    }

    private onSearchExpanded = () => {
        this.setState({ isVisible: false });
    };

    private onSearchCollapsed = () => {
        this.setState({ isVisible: true });
    };
}

// Register the breadcrumb with the layout manager
VssComponent.register(HeaderBreadcrumb.componentType, HeaderBreadcrumb);
